import { Container } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import * as actions from "../../api/actions/actions";
import { controller, endpoints } from "../../api/actions/api";
import { useState } from "react";

const ViewPage = (props) => {
  const { _getById } = props;
  const { id } = useParams();
  const [value, setValue] = useState();

  useEffect(() => {
    id &&
      _getById(
        endpoints.Page + controller.GetById,
        id,
        null,
        (res) => res.status === 200 && setValue({ ...res.result })
      );

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (value) {
      document.title = value.btnName || "View Page | Strata Management";
    }

    return () => {};
  }, [value]);

  console.log("id: ", id, value);

  return (
    <Container maxWidth="md" className="mt-40">
      <div dangerouslySetInnerHTML={{ __html: value && value.content }} />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  _admin: state.storeData.admin,
});

const mapActionToProps = {
  _getById: actions.getById,
};

export default connect(mapStateToProps, mapActionToProps)(ViewPage);
